import { ApolloClient } from '@apollo/client';
import { getDocumentById } from '../../api/queries_v2';
import { GET_DOCUMENT_ROLE_BY_DOCUMENT_ID } from '../../shared/hooks/useDocumentRole/useDocumentRole';
import { graphql } from '../../gql';
import { CounterpartyPermissionLevel } from '../../types/counterparty-permissions';

type ResponsePayloadType = {
  id: string | number;
};

export const givePossessionToCounterparty =
  ({
    documentId,
    additionalMessage,
    sessionActivities,
    counterpartyPermissionLevel,
    readyToSign,
  }: {
    documentId: string;
    additionalMessage?: string;
    sessionActivities?: string[];
    counterpartyPermissionLevel?: CounterpartyPermissionLevel;
    readyToSign?: boolean;
  }) =>
  (client: ApolloClient<object>): Promise<ResponsePayloadType> => {
    const variables = {
      documentId,
      additionalMessage,
      sessionActivities,
      counterpartyPermissionLevel,
      readyToSign,
    };

    const mutation = graphql(/* GraphQL */`
      mutation givePossessionToCounterparty(
        $documentId: ID!
        $additionalMessage: String
        $sessionActivities: [String]
        $counterpartyPermissionLevel: CounterpartyPermissionLevel
        $readyToSign: Boolean
      ) {
        givePossessionToCounterparty(
          documentId: $documentId
          additionalMessage: $additionalMessage
          sessionActivities: $sessionActivities
          confirm: true
          counterpartyPermissionLevel: $counterpartyPermissionLevel
          readyToSign: $readyToSign
        ) {
          id
        }
      }
    `);

    const refetchQueries = [
      {
        query: getDocumentById,
        variables: {
          documentId,
        },
      },
      {
        query: GET_DOCUMENT_ROLE_BY_DOCUMENT_ID,
        variables: {
          documentId,
        },
      },
    ];

    return client.mutate({ mutation, variables, refetchQueries }).then(({ data }: Record<any, any>) => {
      return data.givePossessionToCounterparty;
    });
  };
